import { breakpoints, Button, theme } from '@notino/react-styleguide';

import { styled } from '@linaria/react';

import { Item } from '../../Item';
import { ItemLink } from '../../styled';

export const SelectedShade = styled.span`
  font-weight: 500;
`;

export const Header = styled.div`
  grid-area: header;
  ${theme.typography.titleLarge}
  text-align: center;
  font-weight: 400 !important;
  padding-bottom: 2rem;

  @media (min-width: ${breakpoints.md}) {
    text-align: start;
    padding-bottom: 1.5rem;
    align-self: flex-end;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: column;

  grid-area: button;
  #pdTryItFirst {
    padding: 0 0 1.5rem;
  }
`;

export const StyledItemLink = styled(ItemLink)`
  grid-area: image;
  padding-bottom: 2rem;

  > div {
    width: auto !important;
  }

  @media (min-width: ${breakpoints.md}) {
    padding: 0 4rem 0 0;
  }
`;

export const StyledItem = styled(Item)`
  margin-bottom: 0;
`;

export const Grid = styled.div`
  padding: 0 1.25rem;
  width: 100%;
  display: grid;
  grid-template-areas:
    'header'
    'image'
    'button';

  @supports not (aspect-ratio: 1 / 1) {
    height: 100vh;
  }

  @media (min-width: ${breakpoints.md}) {
    height: unset;
    grid-template-areas:
      'image header'
      'image button';
  }
`;

export const StyledChooseShadeButton = styled(Button)`
  display: block;
  width: 100%;
  margin: 0 auto;

  @media (min-width: ${breakpoints.md}) {
    padding: 0 4rem;
    margin: 0;
    width: auto;
  }
`;
